import { useEffect } from 'react'
import Layout from '../components/layout'
import './ContactUs.scss'

const ContactUs = (props) => {
  useEffect(() => {
    const s = document.createElement('script')
    s.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js'
    s.async = true
    s.onload = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-260281429398162']",
          'https://form.jotform.com/'
        )
      }
    }
    document.body.appendChild(s)

    return () => {
      try {
        document.body.removeChild(s)
      } catch (e) {}
    }
  }, [])

  return (
    <Layout {...props} className="contact-us">
      <div className="container-fluid">
        <h2 className="text-center">CONTACT US</h2>
  
        <div className="row">
          <div className="col-sm-12">
            <iframe
              id="JotFormIFrame-260281429398162"
              title="uStore Automation Contact Us Form"
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://form.jotform.com/260281429398162"
              frameBorder="0"
              style={{ width: '100%', height: '539px', border: 'none' }}
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </Layout>
  )  
}

export default ContactUs
